import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../../i18n'; // adjust path to match your project's i18n import
import '../../../../../styles/components/iso-certification-section.scss';

const STANDARDS = [
    {
        code: 'ISO 9001:2015',
        nameKey: 'iso_standard_9001_name',
        badge: '/assets/badges/iso-9001-2015.png',
    },
    {
        code: 'ISO 29001:2020',
        nameKey: 'iso_standard_29001_name',
        badge: '/assets/badges/iso-29001-2020.png',
    },
    {
        code: 'ISO 14001:2015',
        nameKey: 'iso_standard_14001_name',
        badge: '/assets/badges/iso-14001-2015.png',
    }
];

class IsoCertificationSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            visibleCount: 3,
        };
        this.handleResize = this.handleResize.bind(this);
        this.slideNext = this.slideNext.bind(this);
        this.slidePrev = this.slidePrev.bind(this);
    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        const w = window.innerWidth;
        let visibleCount = 3;
        if (w <= 600) visibleCount = 1;
        else if (w <= 992) visibleCount = 2;
        this.setState((prev) => ({
            visibleCount,
            currentIndex: Math.min(prev.currentIndex, Math.max(0, STANDARDS.length - visibleCount)),
        }));
    }

    slideNext() {
        const { visibleCount } = this.state;
        const max = Math.max(0, STANDARDS.length - visibleCount);
        this.setState((prev) => ({ currentIndex: Math.min(prev.currentIndex + 1, max) }));
    }

    slidePrev() {
        this.setState((prev) => ({ currentIndex: Math.max(prev.currentIndex - 1, 0) }));
    }

    goToDot(index) {
        this.setState({ currentIndex: index });
    }

    render() {
        const { currentIndex, visibleCount } = this.state;
        const isRtl = i18n.language === 'ar';
        const slideWidth = 100 / visibleCount;
        const translateX = isRtl ? currentIndex * slideWidth : -(currentIndex * slideWidth);
        const dotCount = Math.max(0, STANDARDS.length - visibleCount + 1);

        return (
            <section className={'iso-cert' + (isRtl ? ' iso-cert--rtl' : '')} dir={isRtl ? 'rtl' : 'ltr'}>
                <div className="iso-cert__container">
                    <div className="iso-cert__header">
                        <h2 className="iso-cert__title">{i18n.t('iso_title')}</h2>
                        <p className="iso-cert__subtitle">{i18n.t('iso_subtitle')}</p>
                    </div>

                    <div className="iso-cert__carousel">
                        <button
                            type="button"
                            className="iso-cert__arrow iso-cert__arrow--prev"
                            onClick={this.slidePrev}
                            disabled={currentIndex === 0}
                            aria-label={i18n.t('iso_prev')}
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
                                <path d="M15 5l-7 7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>

                        <div className="iso-cert__track-wrap">
                            <div
                                className="iso-cert__track"
                                style={{ transform: `translateX(${translateX}%)` }}
                            >
                                {STANDARDS.map((standard, index) => (
                                    <div className="iso-cert__slide" key={`${standard.code}-${index}`}>
                                        <div className="iso-cert__card">
                                            <img
                                                className="iso-cert__badge-img"
                                                src={standard.badge}
                                                alt={standard.code}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button
                            type="button"
                            className="iso-cert__arrow iso-cert__arrow--next"
                            onClick={this.slideNext}
                            disabled={currentIndex >= STANDARDS.length - visibleCount}
                            aria-label={i18n.t('iso_next')}
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
                                <path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>

                    {dotCount > 1 && (
                        <div className="iso-cert__dots">
                            {Array.from({ length: dotCount }).map((_, i) => (
                                <button
                                    type="button"
                                    key={i}
                                    className={'iso-cert__dot' + (i === currentIndex ? ' iso-cert__dot--active' : '')}
                                    onClick={() => this.goToDot(i)}
                                    aria-label={`${i18n.t('iso_go_to')} ${i + 1}`}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </section>
        );
    }
}

IsoCertificationSection.propTypes = {
    onOpenFullSize: PropTypes.func,
};

IsoCertificationSection.defaultProps = {
    onOpenFullSize: null,
};

export default IsoCertificationSection;